import { render, staticRenderFns } from "./PackingJobs.vue?vue&type=template&id=cdd58af8&"
import script from "./PackingJobs.vue?vue&type=script&lang=js&"
export * from "./PackingJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd58af8')) {
      api.createRecord('cdd58af8', component.options)
    } else {
      api.reload('cdd58af8', component.options)
    }
    module.hot.accept("./PackingJobs.vue?vue&type=template&id=cdd58af8&", function () {
      api.rerender('cdd58af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PackingJobs.vue"
export default component.exports